import { Filter } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu';

export default function StationSelector({ stations, selected, onSelect }) {
  // Get display name for station
  const getStationName = (station) => {
    if (station === 'all') return 'All Stations';
    return station.charAt(0).toUpperCase() + station.slice(1);
  };

  // Station icons mapping
  const getStationIcon = (station) => {
    const icons = {
      'grill': '🔥',
      'fryer': '🍟',
      'salads': '🥗',
      'cold': '❄️',
      'desserts': '🍰',
      'drinks': '🥤',
      'pizza': '🍕',
      'prep': '🔪',
    };
    return icons[station.toLowerCase()] || '📋';
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          className="border-slate-600 text-slate-300 hover:text-white"
          data-testid="station-selector"
        >
          <Filter className="w-4 h-4 mr-2" />
          {selected === 'all' ? 'All Stations' : (
            <>
              <span className="mr-1">{getStationIcon(selected)}</span>
              {getStationName(selected)}
            </>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-slate-800 border-slate-700 min-w-[180px]">
        {stations.map(station => (
          <DropdownMenuItem
            key={station}
            onClick={() => onSelect(station)}
            className={`cursor-pointer ${
              selected === station 
                ? 'bg-orange-500/20 text-orange-400' 
                : 'text-slate-300 hover:text-white hover:bg-slate-700'
            }`}
            data-testid={`station-option-${station}`}
          >
            {station !== 'all' && (
              <span className="mr-2">{getStationIcon(station)}</span>
            )}
            {getStationName(station)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
